import React from "react";
import { Link } from "react-router-dom";

import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

// import button from 'react-bootstrap/button';

import "./AdditionalColleaguesButton.css";

function AdditionalColleaguesButton(props) {
  let rollNumber = props.rollNumber;
  let teacherEmail = props.teacherEmail;
  let classes = props.classes;
  let teachers = props.teachers;
  let name = props.name;
  // console.log(props)

  return (
    <div className="additional-colleague-button-shareclass">
      <Link
        className="additional-colleague-link-shareclass"
        to={`/mycolleagues`}
        state={{
          classDetails: { classes },
          teachers: { teachers },
          name: { name },
          rollNumber: { rollNumber },
          teacherEmail: { teacherEmail },
        }}
      >
        <div className="additional-colleague-content-shareclass">
          <img
            src="../assets/imgs/mycolleagues-icon.png"
            className="additional-colleague-card-img-shareclass"
            alt="Colleague Icon"
          />
          <p className="class-card-text">Add Team Members</p>
        </div>
      </Link>
    </div>
  );
}

export default AdditionalColleaguesButton;
